"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fadeInAnimation = void 0;
const styled_components_1 = require("styled-components");
exports.fadeInAnimation = (0, styled_components_1.keyframes) `
  0% {  
    opacity: 0;
    transform: translate3d(0, -10%, 0); 
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0); 
  }
`;
//# sourceMappingURL=styles.js.map